import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    LinearProgress,
    Fab,
    Stack,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { useSelector } from "react-redux";
import UserStatsCardSkeletonWeb from "../../Components/reports/UserStatsCardSkeleton";
import UserStatsCardWeb from "../../Components/reports/UserStatsCard";
import { getReports } from "../../Slices/reports";

// import { printToFileAsync, printAsync } from "../../Utils/printUtils";

const ReportsWeb = () => {
    const userId = useSelector((state) => state.auth.user?.user.id);
    const token = useSelector((state) => state.auth.user?.jwt);

    const [reports, setReports] = useState([]);
    const [userStatuses, setUserStatuses] = useState({});
    const [myStatus, setMyStatus] = useState("offline");
    const [vrProgress, setVrProgress] = useState(null);

    useEffect(() => {
        if (!token) return;

        const fetchReports = async () => {
            try {
                const res = await getReports(userId, token);
                setReports(res);
            } catch (error) {
                console.error("Błąd pobierania raportów:", error);
            }
        };
        fetchReports();
    }, [token, userId]);

    const printReport = async () => {
        // await printAsync(); 
    };

    const downloadPdf = async () => {
        // await printToFileAsync(); 
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* <Box sx={{ mb: 3 }}>
                <Typography variant="h6">Status użytkowników:</Typography>
                <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                    {Object.entries(userStatuses).map(([id, status]) => (
                        <Typography key={id}>
                            User {id}: <strong>{status}</strong>
                        </Typography>
                    ))}
                    <Box
                        sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            bgcolor: myStatus === "online" ? "green" : "red",
                        }}
                    />
                    <Typography>{myStatus}</Typography>
                </Stack>
            </Box> */}

            {vrProgress?.show && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Typography align="center">
                            Rozpoczęto scenariusz VR {vrProgress?.scenario}
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            value={vrProgress?.progress || 0}
                            sx={{ height: 20, borderRadius: 2, my: 1 }}
                        />
                        <Typography align="center">Progress: {vrProgress?.progress}%</Typography>
                    </CardContent>
                </Card>
            )}

            {vrProgress && <UserStatsCardSkeletonWeb vrProgress={vrProgress} />}

            <Stack spacing={2}>
                {reports?.map((report) => (
                    <Card key={report.id} elevation={0} sx={{ mb: 0 }}>
                        <CardContent>
                            <UserStatsCardWeb report={report} reports={reports} />
                        </CardContent>
                    </Card>
                ))}
            </Stack>

            <Stack direction="row" spacing={2} mt={3} justifyContent="center">
                <Fab color="primary" variant="extended" onClick={downloadPdf}>
                    <DownloadIcon sx={{ mr: 1 }} /> Pobierz PDF
                </Fab>
                <Fab color="secondary" variant="extended" onClick={printReport}>
                    <PrintIcon sx={{ mr: 1 }} /> Drukuj
                </Fab>
            </Stack>
        </Box>
    );
};

export default ReportsWeb;
